import React from 'react';
import { StyleSheet } from 'react-native';
import { CommonProperties, CommonStyles } from '../../styles';
import Button, { BUTTON_TYPES } from '../Button';
import RowView from '../RowView';
import SpeakerWidget from '../TripEvents/SpeakerWidget';

const SpeakerSection = ({ list, onAdd, onRemove, onUpdate }) => {
  return (
    <>
      {list &&
        Object.values(list).map((speaker, index, arr) => (
          <>
            <SpeakerWidget key={speaker.id} speaker={speaker} onUpdate={onUpdate} />
            <RowView
              style={
                index === arr.length - 1 ? CommonStyles.justifyBetween : CommonStyles.justifyEnd
              }
            >
              {index === arr.length - 1 ? (
                <Button
                  type={BUTTON_TYPES.TEXT}
                  style={styles.submitButton}
                  label="Add Meeting"
                  labelStyle={CommonStyles.h3}
                  onPress={onAdd}
                />
              ) : null}
              <Button
                type={BUTTON_TYPES.TEXT}
                style={styles.submitButton}
                label="Remove"
                labelStyle={CommonStyles.h3}
                onPress={() => onRemove(speaker.id)}
              />
            </RowView>
          </>
        ))}
    </>
  );
};

const styles = StyleSheet.create({
  submitButton: {
    alignItems: 'flex-start',
    ...CommonProperties.py3,
    ...CommonProperties.borderRadius4,
  },
});

export default SpeakerSection;
